import { useQuery } from '@tanstack/react-query';
import axios from 'axios';

import {
  ALL_ORGANIZATION_PERMISSIONS_QUERY_KEY,
  ORGANIZATION_PERMISSIONS_API_URL
} from '@/constants';
import { apiUrl, getQueryParams } from '@/helpers';

export const organizationPermissionsEndpoints = {
  getAllOrganizationPermissions: (
    searchQuery?: string,
    sortingField?: string,
    sortingAsc?: boolean
  ) =>
    axios.get(
      `${apiUrl()}${ORGANIZATION_PERMISSIONS_API_URL}${getQueryParams({
        'sorting.Field': sortingField as string,
        'sorting.Asc': sortingAsc as boolean,
        'search.Text': searchQuery as string
      })}`
    )
};

export const getAllOrganizationPermissions = (
  searchQuery?: string,
  sortingField?: string,
  sortingAsc?: boolean
) => {
  return useQuery(
    [ALL_ORGANIZATION_PERMISSIONS_QUERY_KEY, { searchQuery, sortingField, sortingAsc }],
    () =>
      organizationPermissionsEndpoints.getAllOrganizationPermissions(
        searchQuery,
        sortingField,
        sortingAsc
      )
  );
};
